import trans from './utils/transFunction';

// Register trans function
Vue.prototype.trans = trans;
window.trans = trans;

// Set csrf variable
let token = document.head.querySelector('meta[name="csrf-token"]').content;
Vue.prototype.csrf = token;
window.csrf = token;

// Register components automatically
const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Returns old values
 *
 * Usage:
 * old(): Returns array of all old values
 * old('name'): Returns old value of name or empty string
 * old('name', 'Max'): Returns old value of name or Max if empty
 */
Vue.prototype.old = (value = null, returnWhenEmpty = '') => {

    if(!value) {
        return window.oldValues;
    }

    return window.oldValues[value] ? window.oldValues[value] : returnWhenEmpty;

}
window.old = Vue.prototype.old;

/**
 * Returns validation error(s), assumes "default" bag
 *
 * Usage:
 * errors() : returns default bag as array or empty array
 * errors('name') : returns string of errors or separated by comma or empty string
 */
Vue.prototype.errors = (nameOfTheError = null) => {

    var defaultErrorBag = window.validationErrors['default'];
    var thereAreErrors = !!defaultErrorBag;

    if(!nameOfTheError) {
        return defaultErrorBag ? defaultErrorBag : [];
    }

    if(thereAreErrors) {
        return defaultErrorBag[nameOfTheError] ? defaultErrorBag[nameOfTheError].join(', ') : '';
    }

    return '';
}
window.old = Vue.prototype.old;
